import { Typography } from 'antd';
import dayjs from 'dayjs';

const { Text } = Typography;

export const DateTimeCell = ({ value }: { value: string }) => (
  <div style={{ lineHeight: 1.3 }}>
    <Text style={{ fontSize: 13 }}>{dayjs(value).format('MMM D, YYYY')}</Text>
    <br />
    <Text type="secondary" style={{ fontSize: 12 }}>
      {dayjs(value).format('h:mm A')}
    </Text>
  </div>
);
